import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ScaleIcon, MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Acasă',
  to: '/'
}, {
  label: 'Despre Mine',
  to: '/despremine'
}, {
  label: 'Servicii',
  to: '/magazin'
}, {
  label: 'Testimoniale',
  to: '/testimoniale'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <nav className="bg-navy py-4 px-6 sticky top-0 z-50 border-b border-gold/20" data-id="element-130">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-131">
        <Link to="/" className="flex items-center gap-3" data-id="element-132">
          <ScaleIcon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-133" />
          <div data-id="element-134">
            <div className="text-text-light font-heading text-xl font-bold leading-tight" data-id="element-135">
              Andreea Saveli
            </div>
            <div className="text-gold text-[10px] font-label uppercase tracking-label" data-id="element-136">
              Avocat Dreptul Familiei
            </div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8" data-id="element-137">
          {links.map(link => <Link key={link.to} to={link.to} className="text-text-light-secondary hover:text-gold transition-colors font-body text-sm" data-id="element-138">
              {link.label}
            </Link>)}
          <Link to="/contact" className="bg-gold text-navy px-6 py-2 rounded font-label text-xs uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-139">
            Contact
          </Link>
        </div>

        <button className="md:hidden text-text-light" onClick={() => setOpen(v => !v)} aria-label="Meniu" data-id="element-140">
          {open ? <XIcon className="w-6 h-6" data-id="element-141" /> : <MenuIcon className="w-6 h-6" data-id="element-142" />}
        </button>
      </div>

      {open && <div className="md:hidden mt-4 pt-4 border-t border-gold/20 flex flex-col gap-4" data-id="element-143">
          {links.map(link => <Link key={link.to} to={link.to} onClick={() => setOpen(false)} className="text-text-light-secondary hover:text-gold transition-colors font-body text-sm" data-id="element-144">
              {link.label}
            </Link>)}
          <Link to="/contact" onClick={() => setOpen(false)} className="bg-gold text-navy px-6 py-2 rounded font-label text-xs uppercase tracking-label text-center" data-id="element-145">
            Contact
          </Link>
        </div>}
    </nav>;
}